import { apiCall } from './gqlClient';

const CIRCUITEXERCISES_QUERY = `
  query circuitExercises($circuitId: String!) {
    circuitExercises(circuitId: $circuitId)
    {
      id
			circuitId
			exerciseId
			orderIndex
			setSeries
			restTime
			executionMinValue
			executionMaxValue
			deltaValue
			useWeight
			weight
			deltaWeight
			equipSettings
			intensityType
			intensityValue
			techniqueNotes
			tempoEccentricSec
			tempoPauseSec
			tempoConcentricSec
			isUnilateral
			repSchemeType
			repSchemeConfig
			prescribedEffort
      ...fragments
    }
  }`;

export const circuitExercisesApiCall = async ({circuitId}, fragments = null) => apiCall({ query: CIRCUITEXERCISES_QUERY, variables: {circuitId}, fragments });

const CREATECIRCUITEXERCISE_QUERY = `
  mutation createCircuitExercise($input: CircuitExerciseInput!) {
    createCircuitExercise(input: $input)
    {
      id
			circuitId
			exerciseId
			orderIndex
			setSeries
			restTime
			executionMinValue
			executionMaxValue
			deltaValue
			useWeight
			weight
			deltaWeight
			equipSettings
			intensityType
			intensityValue
			techniqueNotes
			tempoEccentricSec
			tempoPauseSec
			tempoConcentricSec
			isUnilateral
			repSchemeType
			repSchemeConfig
			prescribedEffort
      ...fragments
    }
  }`;

export const createCircuitExerciseApiCall = async ({input}, fragments = null) => apiCall({ query: CREATECIRCUITEXERCISE_QUERY, variables: {input}, fragments });

const UPDATECIRCUITEXERCISE_QUERY = `
  mutation updateCircuitExercise($id: String!, $input: CircuitExerciseInput!) {
    updateCircuitExercise(id: $id, input: $input)
    {
      id
			circuitId
			exerciseId
			orderIndex
			setSeries
			restTime
			executionMinValue
			executionMaxValue
			deltaValue
			useWeight
			weight
			deltaWeight
			equipSettings
			intensityType
			intensityValue
			techniqueNotes
			tempoEccentricSec
			tempoPauseSec
			tempoConcentricSec
			isUnilateral
			repSchemeType
			repSchemeConfig
			prescribedEffort
      ...fragments
    }
  }`;

export const updateCircuitExerciseApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATECIRCUITEXERCISE_QUERY, variables: {id, input}, fragments });

const DELETECIRCUITEXERCISE_QUERY = `
  mutation deleteCircuitExercise($id: String!) {
    deleteCircuitExercise(id: $id)
    {
      id
			circuitId
			exerciseId
			orderIndex
			setSeries
			restTime
			executionMinValue
			executionMaxValue
			deltaValue
			useWeight
			weight
			deltaWeight
			equipSettings
			intensityType
			intensityValue
			techniqueNotes
			tempoEccentricSec
			tempoPauseSec
			tempoConcentricSec
			isUnilateral
			repSchemeType
			repSchemeConfig
			prescribedEffort
      ...fragments
    }
  }`;

export const deleteCircuitExerciseApiCall = async ({id}, fragments = null) => apiCall({ query: DELETECIRCUITEXERCISE_QUERY, variables: {id}, fragments });
